import { STRIPE_PAYMENT_ELEMENT_OPTIONS } from '@/pages/customer/pawall/stripe/stripePaymentElementOptions';

export const getPlanPaymentElementOptions = ({
	billingCountry,
	email,
	paymentMethodOrder,
}) => ({
	...STRIPE_PAYMENT_ELEMENT_OPTIONS,
	...(paymentMethodOrder && { paymentMethodOrder }),
	fields: {
		billingDetails: {
			...STRIPE_PAYMENT_ELEMENT_OPTIONS.fields.billingDetails,
			...(email && { email: 'never' }),
		},
	},
	defaultValues: {
		billingDetails: {
			address: {
				country: billingCountry,
			},
			...(email && { email }),
		},
	},
});
